module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ds-week-view-container"
  }, [_c('ds-week-header', _vm._g(_vm._b({
    attrs: {
      "calendar": _vm.calendar,
      "placeholder": _vm.placeholder,
      "placeholder-for-create": _vm.placeholderForCreate,
      "days": _vm.calendar.days,
      "scroll-push": _vm.scrollPush
    }
  }, 'ds-week-header', {
    $scopedSlots: _vm.$scopedSlots
  }, false), _vm.$listeners)), _vm._v(" "), _c('div', {
    staticClass: "ds-week-view-bottom"
  }, [_c('div', {
    ref: "scrollArea",
    staticClass: "ds-week-view-scrollable"
  }, [_c('div', {
    ref: "pane",
    staticClass: "ds-week-view-pane",
    style: (_vm.dayHeight)
  }, [_c('div', {
    staticClass: "ds-week"
  }, [_c('div', {
    staticClass: "ds-hour-list"
  }, _vm._l((_vm.hours), function(hour, i) {
    return _c('div', {
      staticClass: "ds-hour",
      class: _vm.hourClasses[i]
    }, [_c('div', {
      staticClass: "ds-hour-text"
    }, [_vm._v(_vm._s(hour))])])
  })), _vm._v(" "), _vm._l((_vm.calendar.days), function(day) {
    return [_c('ds-day-times', _vm._g(_vm._b({
      key: day.dayIdentifier,
      attrs: {
        "day": day,
        "placeholder": _vm.placeholder,
        "placeholder-for-create": _vm.placeholderForCreate,
        "calendar": _vm.calendar
      }
    }, 'ds-day-times', {
      $scopedSlots: _vm.$scopedSlots
    }, false), _vm.$listeners))]
  })], 2)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30ccf664","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DaysView.vue
// module id = 402
// module chunks = 1